/* global yett */

const init = () => {
	const banner = document.getElementById( 'cookie-notice' );
	const bannerOverlay = document.getElementById( 'bk-jdrf-gform__overlay' );
	const agree = document.getElementById( 'cookie-agree' );
	const decline = document.getElementById( 'cookie-decline' );
	const consentCookie = window.Cookies.get( 'jdrf_cookie_consent' );

	if ( 'true' === consentCookie ) {
		yett.unblock();
		window.Cookies.set( 'jdrf_cookie_consent', 'true', { expires: 365 } );
		return;
	} else {
		banner.style.display = 'block';
	}
	
	const fadeElementOverlay = ( e ) => {
		let style = e.style;

		style.display = 'none';
	};

	const fadeElement = ( e ) => {
		let style = e.style;

		style.opacity = 1;

		( function fade() {
			0 > ( style.opacity -= .1 ) ? style.display = 'none' : setTimeout( fade, 40 );
		} )();
	};

	const agreeClick = () => {
		yett.unblock();
		window.Cookies.set( 'jdrf_cookie_consent', 'true', { expires: 365 } );
		fadeElement( banner );
		fadeElementOverlay( bannerOverlay );
	};

	const declineClick = () => {
		window.Cookies.set( 'jdrf_cookie_consent', 'true', { expires: 365 } );
		fadeElement( banner );
		fadeElementOverlay( bannerOverlay );
	};

	agree.addEventListener( 'click', agreeClick );
	decline.addEventListener( 'click', declineClick );
};

export default {init};
